var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36289_127164)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M10.0032 18.1607C14.5103 18.1607 18.164 14.507 18.164 9.99995C18.164 5.49287 14.5103 1.83919 10.0032 1.83919C5.49611 1.83919 1.84244 5.49287 1.84244 9.99995C1.84244 14.507 5.49611 18.1607 10.0032 18.1607Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8497,
    cy: 10.002,
    r: 1.17392,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.002,
    cy: 10.002,
    r: 1.17392,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.15439,
    cy: 10.002,
    r: 1.17392,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36289_127164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.ddd03a17c730b1c9438a57f7f9825dad.svg";
export { ForwardRef as ReactComponent };